import React from 'react';
import { IGdnInvoicesListConfig, IGdnInvoicesListResources } from '../gdn-invoices-list.props.autogenerated';
import { ICultureInfoFormatter, RichTextComponent } from '@msdyn365-commerce/core-internal';
import { IGetGdnOpenInvoiceDetailsResponse } from '../../../actions/DataServiceEntities.g';

export interface IInvoicePaymentTotals {
    resources: IGdnInvoicesListResources;
    config: IGdnInvoicesListConfig;
    cultureFormatter: ICultureInfoFormatter;
    invoicePaymentTotals: IGetGdnOpenInvoiceDetailsResponse;
}

export const InvoicePaymentTotals: React.FC<IInvoicePaymentTotals> = props => {
    const {
        resources,
        config,
        cultureFormatter: { formatCurrency },
        invoicePaymentTotals: { CurrentAmountTotal, FutureAmountTotal, InvoiceTotalDueAmount, PastDueAmountTotal }
    } = props;
    const baseClassName = 'msc-invoices-list__invoice-payment-totals';

    return (
        <div className={baseClassName}>
            <div className={`${baseClassName}__totals`}>
                <div className={`${baseClassName}__totals__row`}>
                    <span className={`${baseClassName}__totals__label`}>{resources.futureDueText}</span>
                    <span className={`${baseClassName}__totals__amount`}>{formatCurrency(FutureAmountTotal)}</span>
                </div>
                <div className={`${baseClassName}__totals__row__past-due`}>
                    <span className={`${baseClassName}__totals__label`}>{resources.pastDueText}:</span>
                    <span className={`${baseClassName}__totals__amount`}>{formatCurrency(PastDueAmountTotal)}</span>
                </div>
                <div className={`${baseClassName}__totals__row`}>
                    <span className={`${baseClassName}__totals__label`}>{resources.currentDueText}</span>
                    <span className={`${baseClassName}__totals__amount`}>{formatCurrency(CurrentAmountTotal)}</span>
                </div>

                <div className={`${baseClassName}__totals__separator`} />

                <div className={`${baseClassName}__totals__row ${baseClassName}__totals__row--total`}>
                    <span className={`${baseClassName}__totals__label`}>{resources.totalAmountDueText}</span>
                    <span className={`${baseClassName}__totals__amount`}>{formatCurrency(InvoiceTotalDueAmount)}</span>
                </div>
            </div>

            <div className={`${baseClassName}__disclaimer`}>
                {config.invoiceTotalsDisclaimerMessage ? (
                    <RichTextComponent text={config.invoiceTotalsDisclaimerMessage} />
                ) : (
                    <>
                        <span className={`${baseClassName}__disclaimer-note`}>Note:</span> Monthly statements may differ from these totals
                    </>
                )}
            </div>
        </div>
    );
};

export default InvoicePaymentTotals;
